
export default {
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAvailable() {
      return this.$dateFns.isPast(this.$dateFns.parseISO(this.video.start));
    },
  },
};
